// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@4.3.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".categories-menu[data-v-e0022866]{top:100%!important;height:-webkit-fit-content!important;height:-moz-fit-content!important;height:fit-content!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
